import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

//Lazy component
const DashBoard = lazy(() => import("@pages/DashBoard"));
const UserProfile = lazy(() => import("@/pages/UserProfile"));
const PhotoUploader = lazy(() => import("@/pages/PhotoUploader"));
const Layout = lazy(() => import("@/layouts/Layout"));
const Album_Management = lazy(() => import("@/pages/Album_Management"));

const MSRManagement = lazy(() => import("@/pages/MSRManagement"));
const ComponentLoading = lazy(() => import("@/components/ComponentLoading"));
const Category = lazy(() => import("@/pages/Category"));

//Non Lazy component
import Login from "@pages/Login";
import FirstTimeLogin from "@pages/FirstTimeLogin";
import AddNewStyle from "@/pages/AddNewStyle";
import AddCategory from "@/pages/AddCategory";
import Permission from "@/pages/Permission";
import UsersPage from "@/pages/UsersPage";
import Notification from "@/pages/Notification";
import StyleDetail from "@/pages/StyleDetail";
import StyleSearchResults from "@/pages/StyleSearchResults";
import UserPage from "@/pages/UserPage";

import StyleOrderUpdated from "@/pages/StyleOrderUpdated";
import Website_Cover_Photo from "@/pages/Website_Cover_Photo";
import EmailVarification from "@/pages/EmailVarification";
import MSRSeasonDetail from "@/components/MSRSeasonDetails";
import RestoreStyle from "@/pages/RestoreStyle";
import { BulkCreate } from "@/pages/BulkCreate";
import TagManegement from "@/pages/TagManegement";
import { UserAnalyticsPage } from "@/pages/UserAnalytics";
import { UserManagementPage } from "@/pages/UserManagementPage";
import CategoryHierarchyTable from "@/components/CategoryList";
import ArchiveStyle from "@/pages/ArchiveStyle";

function AppRoutes() {
  return (
    <>
      <Suspense fallback={<ComponentLoading />}>
        <Routes>
          <Route
            path="/dashboard"
            element={
              <Layout>
                <DashBoard />
              </Layout>
            }
          />
          <Route
            path="/user-profile"
            element={
              <Layout>
                <UserProfile />
              </Layout>
            }
          />

          {/* User */}
          <Route
            path="/upload-image"
            element={
              <Layout>
                <PhotoUploader />
              </Layout>
            }
          />
          <Route
            path="/user-analytics"
            element={
              <Layout>
                <UserAnalyticsPage />
              </Layout>
            }
          />
          <Route
            path="/album-management"
            element={
              <Layout>
                <Album_Management />
              </Layout>
            }
          />
          <Route
            path="/website-cover-photo"
            element={
              <Layout>
                <Website_Cover_Photo />
              </Layout>
            }
          />
          <Route
            path="/tag-management"
            element={
              <Layout>
                <TagManegement />
              </Layout>
            }
          />
          <Route
            path="/user-management"
            element={
              <Layout>
                <UserManagementPage />
              </Layout>
            }
          />
          <Route
            path="/style/details/:style_id"
            element={
              <Layout>
                <StyleDetail />
              </Layout>
            }
          />
          <Route
            path="/style/searchdetails/:searchTerm"
            element={
              <Layout>
                <StyleSearchResults />
              </Layout>
            }
          />

          <Route
            path="/users"
            element={
              <Layout>
                <UserPage />
              </Layout>
            }
          />

          <Route
            path="/categories"
            element={
              <Layout>
                <CategoryHierarchyTable />
              </Layout>
            }
          />

          <Route
            path="/msr-category-and-years-management"
            element={
              <Layout>
                <MSRManagement />
              </Layout>
            }
          />
          <Route
            path="/msr-season-details/"
            element={
              <Layout>
                <MSRSeasonDetail />
              </Layout>
            }
          />
          <Route
            path="/category/*"
            element={
              <Layout>
                <Category />
              </Layout>
            }
          />
        </Routes>
      </Suspense>

      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/api/auth/v1/auth/verify-email/*"
          element={<EmailVarification />}
        />

        <Route path="/login-first-time/*" element={<FirstTimeLogin />} />
        <Route
          path="/style-management"
          element={
            <Layout>
              <StyleOrderUpdated />
            </Layout>
          }
        />
        <Route
          path="/style-management/:categorySlug"
          element={
            <Layout>
              <StyleOrderUpdated />
            </Layout>
          }
        />
        <Route
          path="/archive-style"
          element={
            <Layout>
              <ArchiveStyle />
            </Layout>
          }
        />
        <Route
          path="/notification"
          element={
            <Layout>
              <Notification />
            </Layout>
          }
        />
        <Route
          path="/staff-user-management"
          element={
            <Layout>
              <UsersPage />
            </Layout>
          }
        />
        <Route
          path="/role-and-permission-management"
          element={
            <Layout>
              <Permission />
            </Layout>
          }
        />
        <Route
          path="/restore-style"
          element={
            <Layout>
              <RestoreStyle />
            </Layout>
          }
        />
        <Route
          path="/add-new-category"
          element={
            <Layout>
              <AddCategory />
            </Layout>
          }
        />
        <Route
          path="/bulk-create"
          element={
            <Layout>
              <BulkCreate />
            </Layout>
          }
        />
        <Route
          path="/add-new-style"
          element={
            <Layout>
              <AddNewStyle />
            </Layout>
          }
        />
      </Routes>
    </>
  );
}

export default AppRoutes;
